module.exports = __webpack_public_path__ + "static/media/037-molecules.eca25166.svg";